import * as React from 'react'

import { i18n } from '@thg-commerce/enterprise-core'
import { Tabs } from '@thg-commerce/gravity-patterns'
import { spacing } from '@thg-commerce/gravity-theme'

interface PersonalisationToggleProps {
  activePersonalisationTabIndex?: number
  setActivePersonalisationTabIndex?: (state: number) => void
  showClassicContent: Boolean
  classicContent: React.ReactNode
  personalisedContent: React.ReactNode
}
export const PersonalisationToggle = (props: PersonalisationToggleProps) => {
  const personalisationI18nText = {
    classic: i18n('personalisation.tab.label.classic'),
    personalised: i18n('personalisation.tab.label.personalised'),
  }

  return (
    <div style={{ marginTop: `${spacing(2)}` }}>
      {props.showClassicContent ? (
        <Tabs
          tabIndex={props.activePersonalisationTabIndex}
          setActiveTabIndex={props.setActivePersonalisationTabIndex}
          disableTabKey={true}
          alternateStyling={true}
          tabs={[
            {
              title: personalisationI18nText.classic,
              content: props.classicContent,
            },
            {
              title: personalisationI18nText.personalised,
              content: props.personalisedContent,
            },
          ]}
        />
      ) : (
        props.personalisedContent
      )}
    </div>
  )
}
